import { render, staticRenderFns } from "./Doubt.vue?vue&type=template&id=96710d5e&scoped=true"
import script from "./Doubt.vue?vue&type=script&lang=js"
export * from "./Doubt.vue?vue&type=script&lang=js"
import style0 from "./Doubt.vue?vue&type=style&index=0&id=96710d5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96710d5e",
  null
  
)

export default component.exports